import {useEffect, useState} from "react";
import styled from 'styled-components';

import {useParams} from "react-router-dom";
import useFeedback from "../../../utils/use_feedback";
import {useCommunitySettings, useSaveSettings} from "../../../api/communities";
import {useSaveClicked} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {FormControl, Select, Stack, Switch, useToast} from "@chakra-ui/react";

const SwitchHeading = styled.div``;

const ContentCommunitySettings = styled(({className}) => {
    const {community} = useParams();
    const {error, feedbackCh} = useFeedback();
    const [settings, setSettings] = useState({
            displayName: '',
            appSafe: '',
            description: '',
            topics: [],
            nsfw: false,
        }
    );
    useCommunitySettings(feedbackCh, community, setSettings);
    const set = (name) => (value) => setSettings((settings) => ({...settings, [name]: value}));

    const saveSettings = useSaveSettings(feedbackCh);
    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    toast({
                        title: `Saving...`,
                        status: 'info',
                        isClosable: true,
                    });
                    await saveSettings(community, settings);
                    toast.closeAll();
                    toast({
                        title: `Saved settings.`,
                        status: 'success',
                        isClosable: true,
                    });
                    setSaving(false);
                }
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Content Restrictions" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>
                    <Stack spacing={'1'} mb={6}>
                        <SwitchHeading style={{padding: '6px 0'}}>Default Post Type</SwitchHeading>
                        <Select value={settings.defaultPostType}
                                onChange={(e) => set('defaultPostType')(e.currentTarget.value)}>
                            <option value="media">Media</option>
                            <option value="link">Link</option>
                            <option value="text">Text</option>
                        </Select>
                    </Stack>
                    <Stack spacing={'1'} mb={6}>
                        <SwitchHeading style={{padding: '6px 0'}}>Default Comment Sort</SwitchHeading>
                        <Select value={settings.defaultCommentSort}
                                onChange={(e) => set('defaultCommentSort')(e.currentTarget.value)}>
                            <option value="top">Top</option>
                            <option value="new">New</option>
                            <option value="old">Old</option>
                            <option value="controversial">Controversial</option>
                        </Select>
                    </Stack>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Allow Text Posts
                        </SwitchHeading>
                        <Switch isChecked={settings.allowTextPosts} onChange={(ev) => set('allowTextPosts')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Allow Link Posts
                        </SwitchHeading>
                        <Switch isChecked={settings.allowLinkPosts} onChange={(ev) => set('allowLinkPosts')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Allow Image Posts
                        </SwitchHeading>
                        <Switch isChecked={settings.allowImagePosts} onChange={(ev) => set('allowImagePosts')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Allow Post Editing
                        </SwitchHeading>
                        <Switch isChecked={settings.allowPostEditing} onChange={(ev) => set('allowPostEditing')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Allow Comment Editing
                        </SwitchHeading>
                        <Switch isChecked={settings.allowCommentEditing} onChange={(ev) => set('allowCommentEditing')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Allow Child Comments
                        </SwitchHeading>
                        <Switch isChecked={settings.allowChildComments} onChange={(ev) => set('allowChildComments')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex'>
                        <SwitchHeading mb='0'>
                            Allow Comments
                        </SwitchHeading>
                        <Switch isChecked={settings.allowComments} onChange={(ev) => set('allowComments')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                </FormContainer>

            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 15px;
    padding: 2px 0;
  }
`;

export default ContentCommunitySettings;
